export const DATETIME = {
  FUll: 'DD [tháng] MM, YYYY',
  SHORT: 'DD/MM/YYYY',
  HASDAYINWEEK: 'dddd, [ngày] DD-MM-YYYY',
  DETAIL: 'DD/MM/YYYY HH:mm [GMT]Z',
};
